import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './keycloak-login.magic.css.js';
import script from './keycloak-login.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isBackHomeLinkAndIconEnabled)?_c('div',{staticClass:"login-action",attrs:{"part":"login-action"}},[_c('magic-ui-button',{staticClass:"button button--right",attrs:{"icon":"","tiny":"","no-margin":"","variant":"transparent","part":"button button--right","aria-label":"✕"},on:{"click":function($event){return _vm.onClose()}}},[_c('magic-ui-icon',{staticClass:"icon",attrs:{"name":"close","part":"icon"}})],1)],1):_vm._e(),_vm._v(" "),_c('form',{ref:"login-form",staticStyle:{"display":"none"},attrs:{"action":_vm.loginAction,"method":"post"}},[_c('input',{attrs:{"type":"text","id":"username","name":"username","autocomplete":"off"}}),_vm._v(" "),_c('input',{attrs:{"type":"password","id":"password","name":"password","autocomplete":"off"}})]),_vm._v(" "),(_vm.$t('login.hint'))?_c('magic-ui-text',{staticClass:"text",attrs:{"tag":"p","part":"text","content":_vm.$t('login.hint')}}):_vm._e(),_vm._v(" "),(_vm.formConfig)?_c('magic-form-builder',{domProps:{"config":_vm.formConfig,"initialState":_vm.initialState},on:{"form-submit":function($event){return _vm.submit($event.detail[0])}}}):_vm._e(),_vm._v(" "),_c('magic-ui-link',{staticClass:"link",attrs:{"part":"link","href":_vm.loginResetCredentialsUrl}},[_vm._v("\n        "+_vm._s(_vm.$t('login.actions.forgot'))+"\n    ")]),_vm._v(" "),_c('hr',{staticClass:"divider",attrs:{"part":"divider"}}),_vm._v(" "),_c('magic-ui-link',{attrs:{"to":_vm.RoutablePage.SIGN_UP}},[_c('magic-ui-button',{attrs:{"wide":"","variant":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('login.actions.create'))}})],1),_vm._v(" "),(_vm.isBackHomeLinkAndIconEnabled)?_c('magic-ui-link',{staticClass:"link",attrs:{"part":"link","href":_vm.redirectUri}},[_vm._v("\n        "+_vm._s(_vm.$t('login.actions.back-home'))+"\n    ")]):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5b06183e_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-5b06183e";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
